import axios from 'axios';

export const sendContactUsFormDataApiAction = (form) => {
  return axios({
    method: 'post',
    url: 'https://getform.io/f/af2bfc12-6583-4e29-b258-0d24d4a39fdf',
    data: new FormData(form),
  });
};
